import {RankedModeTypes} from '../../../../shared/GameEnums'
import {LeaderboardConstants} from '../../../../shared/leaderboard_data/LeaderboardConstants'
import {UIWLeaderboardController} from './UIWLeaderboardController'
import {ViewPopup} from '../../../shared/scripts/ui_popup/ViewPopup'
import {UIProfileSettingsRegionChangeController} from '../../../shared/scripts/profile/UIProfileSettingsRegionChangeController'
import {StorageWrapper} from '../../../shared/scripts/StorageWrapper'
import {ClientUserState} from '../../../shared/scripts/ClientUserState'
import {UIDLeaderboardCTAController} from './UIDLeaderboardCTAController.ts'

export class UIDLeaderboardController extends UIWLeaderboardController {
    protected initCTAController() {
        this.ctaController = new UIDLeaderboardCTAController()
    }

    async fetchStickyRowData() {
        void this.fetchMyStickyRowData()
    }

    protected override async onRankedModeChange(rankedMode: RankedModeTypes) {
        this.switchRankingCategoryTypeData(rankedMode, this.leaderboardUrl, this.searchTerm)
        await this.fetchMyStickyRowData()
        this.showChangeRegionIncentivePopup()
    }

    protected override initiateParametersFromUrl() {
        this.leaderboardUrl = LeaderboardConstants.globalLeaderboardUrl
        this.searchTerm = ''
    }

    showChangeRegionIncentivePopup() {
        const alreadyShown = StorageWrapper.getDiscordChangeRegionIncentivePopupShown()
        if(alreadyShown) return

        const isRanked = this.stickyRowController.isRanked
        if(!isRanked) return

        const changedRegionManually = ClientUserState.userState?.regionUpdated != undefined
        if(changedRegionManually) return

        const popup = new ViewPopup({key: 'strings:popups.changeRegionIncentive.title'},
            {key: 'strings:popups.changeRegionIncentive.body'},
            () => UIProfileSettingsRegionChangeController.showChangeRegionPopup(),
            () => undefined,
            true)
        popup.removeXButton()
        popup.show()
        StorageWrapper.setDiscordChangeRegionIncentivePopupShown()
    }
}
